<template>
  <div class="main">
    <report-top v-if="!scan"> </report-top>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectData = $event"
    >
      <template #imgs="{ row }">
        <imgList :data="row.filesPathList"></imgList>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="downLoad(row, index)">下载文件</Button>
      </template>
    </Table>

    d>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
        },
        {
          title: "文件名",
          key: "name",
        },
        {
          title: "文件格式",
          key: "formate",
        },
        {
          title: "备注信息",
          key: "remark",
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 20,
        },
      ],
      tableData: [
        {
          link: "https://www.scsxzr.com/files/ly-cloud/jielongSys/微信员工端用户操作手册.doc",
          name: "微信员工端用户操作手册",
          remark: "",
          formate: "DOCX",
        },
        {
          link: "https://www.scsxzr.com/files/ly-cloud/jielongSys/系统演讲培训材料v6-建瓯.docx",
          name: "系统演讲培训材料v6-建瓯",
          remark: "",
          formate: "DOCX",
        },
        {
          link: "https://www.scsxzr.com/files/ly-cloud/jielongSys/智慧城市3.0app-release.apk",
          name: "智慧城市3.0app-release",
          remark: "",
          formate: "APK",
        },
        {
          link: "https://www.scsxzr.com/files/ly-cloud/jielongSys/智慧城市3.0管理后台用户操作手册.doc",
          name: "智慧城市3.0管理后台用户操作手册",
          remark: "",
          formate: "DOC",
        },
        {
          link: "https://www.scsxzr.com/files/ly-cloud/jielongSys/智慧城市4.0微信公众号.zip",
          name: "智慧城市4.0微信公众号",
          remark: "",
          formate: "ZIP",
        },
      ],

      forms: [],
      searchItem: { pageNumber: 1, pageSize: 50, keyword: "" },

      total: 0,
      selectData: [],
    };
  },
  methods: {
    downLoad(row) {
      window.open(row.link);
    },
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/word.vue